class BadgeFormatter {

    badgeFormat(data) {
        if (!data) return null;

        return {
            id: data.id ?? null,
            number: data.number ?? null,
            ref: data.ref ?? null,
            slot: data.slot ?? null,
            status: data.status ?? "NEW",
            lastActivity: data.lastActivity ?? null,

            clientId: data.clientId ?? null,
            driverId: data.driverId ?? null,
            badgeProfileId: data.badgeProfileId ?? null,

            driver: data.driver ?? null,
            balises: data.balises ?? [],
            badgeProfile: data.badgeProfile ?? null,
        };
    }

    badgesFormat(data) {
        if (!Array.isArray(data)) return [];

        return data
            .map(badge => this.badgeFormat(badge))
            .filter(Boolean);
    }
}

export default new BadgeFormatter();